import {Box, Link, ListItemText, Stack, Typography} from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';

const Contact = () => {
    return (
        <Stack direction="column" spacing={4} sx={{p: 3, maxWidth: 600}}>
            <Typography variant="h4" component="h1" fontWeight="medium">
                Contact
            </Typography>

            <Stack direction="row" spacing={2} alignItems="flex-start">
                <InfoOutlineIcon color="primary"/>
                <Typography variant="body1">
                    Pentru orice întrebări legate de Taberele Chiron, reprezentații companiei <Link
                    href="https://www.aventurasicalatorii.ro/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {"  "}Aventură și Călătorii
                </Link>
                    {" "}vă stau oricând la dispoziție pentru a vă oferi
                    cea mai bună experiență! Pentru a lua legătura cu unul dintre reprezentații noștrii, ne puteți scrie
                    un email sau suna pe unul din numerele afișate.
                </Typography>
            </Stack>

            {/*emails*/}
            <Box>
                <Stack direction="row" alignItems="center" spacing={1} sx={{mb: 2}}>
                    <MailOutlineIcon color="primary"/>
                    <Typography variant="h6" component="h2">
                        Adrese de email
                    </Typography>
                </Stack>
                <Stack direction="column" spacing={2} alignItems="start" pl={4}>
                    <Link href="mailto:taberelechiron@gmail.com"
                          underline="hover"
                          color="text.primary"
                          target="_blank">taberelechiron@gmail.com</Link>
                    <Link
                        href="mailto:contact@aventurasicalatorii.ro"
                        underline="hover"
                        color="text.primary"
                        target="_blank">contact@aventurasicalatorii.ro</Link>
                </Stack>
            </Box>

            {/*phones*/}
            <Box>
                <Stack direction="row" alignItems="center" spacing={1} sx={{mb: 2}}>
                    <PhoneIcon fontSize="small" color="primary"/>
                    <Typography variant="h6" component="h2">
                        Numere de telefon
                    </Typography>
                </Stack>
                <Stack direction="column" spacing={1} pl={4}>
                    <Stack direction="row" spacing={2} alignItems="center">
                        <ListItemText>
                            <Link href="tel:+4074171780" underline="hover" color="text.primary">0741 171 780</Link>
                        </ListItemText>
                    </Stack>
                    <Stack direction="row" spacing={2} alignItems="center">
                        <ListItemText>
                            <Link href="tel:+40722388217" underline="hover" color="text.primary">0722 388 217</Link>
                        </ListItemText>
                    </Stack>
                    <Stack direction="row" spacing={2} alignItems="center">
                        <ListItemText>
                            <Link href="tel:+40723196303" underline="hover" color="text.primary">0723 196 303</Link>
                        </ListItemText>
                    </Stack>
                </Stack>
            </Box>
        </Stack>
    )
}

export default Contact;